import WatchVideoTextFrame from "src/assets/svg-assets/watch-video-text-frame";
import PatchHighlightTextFrame from "src/assets/svg-assets/patch-highlight-text-frame";
import { usePatchStore } from "src/services/patch-ecosystem-store";
import { PatchService } from "src/services/patch-service";

function PatchHeaderSection() {
  const { patchInfo } = usePatchStore();

  return (
    <>
      <div className="relative z-50 mt-10 flex min-h-[423px] w-full items-center justify-center border-b border-[#00FFD5] ">
        <div className="relative z-50 flex  h-full w-full items-center justify-between px-20 py-12  pb-14 max-[1202px]:flex-col max-[1202px]:items-start max-[1202px]:gap-14 max-[615px]:px-10 max-[533px]:px-5">
          <div className="flex h-full flex-col items-center justify-between gap-[112px] max-[1202px]:gap-10">
            <div className="flex w-full items-center justify-start">
              <div className="flex flex-col items-center justify-center gap-2">
                <div className="flex h-10 items-center justify-center gap-4 rounded-full border border-[#393939] bg-neutral-900 px-4 py-[4.5px] ">
                  <p className="text-center font-poppins text-[14px] font-medium leading-5 text-[#717171] ">
                    Current Patch
                  </p>
                  <div className=" h-full w-px bg-[#393939] "></div>
                  <p className="text-center font-unbounded text-base font-extrabold text-[#8E8E8E] ">
                    {patchInfo.patch}
                  </p>
                </div>
                <div className="flex items-center justify-center font-poppins text-[14px] leading-5 text-[#555555]">
                  <span>Next Patch:</span>
                  {""}
                  <span className="font-semibold">{PatchService.getNextPatchDate()}</span>
                </div>
              </div>
            </div>
            <div className="flex flex-col items-start justify-start gap-8">
              <div className="flex items-center justify-center gap-8 text-[12px] leading-5 tracking-[1px] ">
                <div className="flex h-6  min-w-fit items-center justify-center rounded-full bg-[#71717140] px-2.5 font-poppins text-[#aaa] ">
                  SoloQ Strategists
                </div>
                <div className="flex  h-6 min-w-fit items-center justify-center rounded-full bg-[#71717140] px-2.5 font-poppins text-[#aaa] ">
                  Competitive Teams
                </div>
                <div className="flex  h-6 min-w-fit items-center justify-center rounded-full bg-[#71717140] px-2.5 font-poppins text-[#aaa] ">
                  Coaches & Analysts
                </div>
              </div>
              <div className="flex flex-col items-start justify-center whitespace-nowrap text-neutral-0 ">
                <h1 className="font-unbounded text-[24px] font-extrabold  ">LEAGUE OF LEGENDS</h1>
                <h1 className="font-unbounded text-[64px] font-black leading-[64px] ">
                  TIER LISTS
                </h1>
              </div>
            </div>
          </div>
          <div className="flex h-full items-end justify-center max-[1202px]:h-fit max-[1202px]:w-full ">
            <div className="relative h-[320px] w-[385px] min-w-[285px] max-w-[385px] max-[1202px]:flex max-[1202px]:h-fit max-[1202px]:min-w-full max-[1202px]:flex-row-reverse max-[1202px]:justify-start   max-[765px]:items-start max-[765px]:gap-10">
              <iframe
                src={`https://www.youtube.com/embed/${patchInfo.patchVideo.split("v=")[1]?.split("&")[0]}?autoplay=1&mute=1&loop=1&playlist=${patchInfo.patchVideo.split("v=")[1]?.split("&")[0]}`}
                title="Patch Video"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                className="pointer-events-none h-full w-full max-[1202px]:hidden"
              ></iframe>
              <div className="absolute bottom-0  hidden h-14 cursor-pointer items-center justify-center gap-4 rounded-full border-[0.5px] border-[#00FFD4] bg-[#00FFD51F] px-8 py-4 max-[1202px]:relative max-[1202px]:justify-between">
                <img
                  className=" h-8px w-[20.08px] "
                  src={require("../assets/icons/procoms-logo.png")}
                  alt="procoms-logo"
                />
                <p className=" whitespace-nowrap text-center font-unbounded text-base font-medium text-neutral-0">
                  FULL PATCH BREAKDOWN
                </p>
                <img
                  className="h-6 w-6"
                  src={require("../assets/icons/white-arrow.png")}
                  alt="white-arrow"
                />
              </div>
              <div
                onClick={() => {
                  window.open(patchInfo.patchVideo, "_blank");
                }}
                className="absolute right-0 top-0 cursor-pointer max-[1202px]:relative max-[1202px]:flex max-[1202px]:items-center max-[1202px]:justify-center"
              >
                <WatchVideoTextFrame />
              </div>
            </div>
          </div>

          <div className="mt-auto flex h-full flex-col items-end gap-4 max-[1202px]:absolute max-[1202px]:right-40  max-[1202px]:top-12 max-[1202px]:h-fit max-[765px]:hidden">
            <PatchHighlightTextFrame />
            <div className="font-unbounded text-[32px] font-bold leading-[34px] text-neutral-0">
              AMBESSA
            </div>
          </div>
        </div>
      </div>
      <img
        src={require("../assets/frames/ambessa-frame.png")}
        alt="ambessa-logo"
        className="absolute  right-0 top-0 z-10 max-[1202px]:top-[59px] max-[1202px]:h-[448px] max-[765px]:right-0 max-[765px]:top-10 max-[765px]:h-[264px]"
      />
    </>
  );
}

export default PatchHeaderSection;
